import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SidenavComponent } from './sidenav/sidenav.component';
import { IndicadorFilaComponent } from './components/indicador-fila/indicador-fila.component';
import { IndicadorOrgaoComponent } from './components/indicador-orgao/indicador-orgao.component';

import { HttpClientModule } from '@angular/common/http';
import { ButtonModule } from 'primeng/button';

import { RouteChangeService } from './utilidades/route-change.service';
import { Title } from '@angular/platform-browser';
import { OAuthService } from 'angular-oauth2-oidc';

import { MatDialog } from '@angular/material/dialog';
import { AjudaComponent } from './components/ajuda/ajuda.component';
import { LoadingIndicadoresComponent } from './loading-indicadores/loading-indicadores.component';
import { environment } from '../environments/environments';
import { authConfigIdp } from './auth/idp.sp/auth-config-idp';
import { AuthService } from './service/auth.service';

interface SideNavToggle {
    collapsed: boolean;
    screenWidth: number;
}

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [
        //BrowserModule,
        CommonModule,
        RouterOutlet,
        HttpClientModule,
        HeaderComponent,
        HomeComponent,
        SidenavComponent,
        IndicadorOrgaoComponent,
        IndicadorFilaComponent,
        LoadingIndicadoresComponent,
        ButtonModule,
        //InputTextModule

    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    //providers: [provideClientHydration()],
})


export class AppComponent {
    title = 'Sala de Situação - Sistema de Atendimento';
    hideDiv: boolean = false;
    @Output() themeToggle = new EventEmitter<string>();
    public themeClass: string = "";
    isDarkTheme: boolean = false;
    isSieNavCollapsed = false;
    screenWihdth = 0;

    private apiUrl = environment.API_URL;

    constructor(private router: Router, private authService: AuthService, private titleService: Title, private routeChangeService: RouteChangeService, @Inject(DOCUMENT) private document: Document, private oauthService: OAuthService,
        public dialog: MatDialog) {
        this.routeChangeService.getRouteChange().subscribe(url => {
            this.checkURL(url);
            this.titleService.setTitle(this.title);
        });
        const localStorage = document.defaultView?.localStorage;
        if (localStorage) {
            var NewVisu = localStorage.getItem('MODOTELA');
            this.isDarkTheme = NewVisu == null ? false : NewVisu == "LIGHT" ? false : true;
        }

        // Configura IDP antigo
        //this.configureIDP();

        // Tenta restaurar sessão CyberArk (novo login)
        this.tryRestoreCyberArkSession();
    }

    checkURL(url: string): void {
        this.hideDiv = (url === '/iniciar' || url === '/loading');
    }

    onToggleSideNav(data: SideNavToggle) {
        this.screenWihdth = data.screenWidth;
        this.isSieNavCollapsed = data.collapsed;
    }

    public toggleTheme(theme: string) {
        console.log("APP", theme);
        if (theme == "LIGHT") {
            this.isDarkTheme = false;
            this.themeClass = '';
        }
        else if (theme == "DARK") {
            this.isDarkTheme = true;
            this.themeClass = 'dark-theme';
        }
        this.themeToggle.emit(theme);
    }

    openDialog() {
        this.dialog.open(AjudaComponent, {
            width: '80%',
            height: '80%'
        })
    }

    ngOnInit() {
        this.configureIDP();

        this.tryRestoreCyberArkSession();
    }

    // -------------------------------
    // IDP antigo (não chama backend)
    // -------------------------------
    private configureIDP() {
        this.oauthService.configure(authConfigIdp);
        this.oauthService.loadDiscoveryDocumentAndTryLogin();
        this.oauthService.loadDiscoveryDocument(environment.well_known);
        this.oauthService.setupAutomaticSilentRefresh();
        this.oauthService.tryLogin();

        // observa eventos do OAuthService e grava provider quando token válido
        this.oauthService.events.subscribe(() => {
            if (this.oauthService.hasValidAccessToken()) {
                localStorage.setItem('auth_provider', 'IDP');
                localStorage.setItem('token', this.oauthService.getAccessToken());
            }
        });
    }

    // -------------------------------
    // CyberArk (novo login) → chama backend
    // -------------------------------
    private tryRestoreCyberArkSession() {
        if (!location.search.includes('code=')) return;

        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');
        if (!code) return;

        this.authService.exchangeCyberArkCode(code).subscribe({
            next: (data) => {
                if (data.jwt) {
                    console.log(data.jwt);
                    //alert(data.jwt);
                    
                    localStorage.setItem('login', data.usuario);
                    localStorage.setItem("token", data.jwt);
                    localStorage.setItem("cpf", data.usuario);
                    localStorage.setItem("expiresToken", data.expires);
                    localStorage.setItem("auth_provider", "CYBERARK");
                    console.log("Login CyberArk finalizado (service)");

                    

                     // INICIAR RENOVAÇÃO AUTOMÁTICA SOMENTE CYBERARK
                     this.authService.startAutoRefresh();
                    this.router.navigateByUrl("/dashboard");
                }
            },
            error: (err) => {
                console.error("Erro ao trocar código CyberArk:", err);
            }
        });
    }





}
function provideClientHydration(): import("@angular/core").Provider {
    throw new Error('Function not implemented.');
}

